import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { TableSearchInput } from 'common/components/table-filter-component';
import { landlordBookingStatus } from 'common/constants/booking';
import { titleCase } from 'common/helpers/titleCase';
import { dayFormatType, formatDay } from '~helpers/day';
import { colors } from 'common/constants/colors';

export const searchFilterAddon = key => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div className="partner__body__list__columns-dropdown">
      <TableSearchInput
        field={`${key}`}
        value={selectedKeys}
        onChange={(_fieldName, value) => {
          if (value) {
            setSelectedKeys(value);
            confirm();
          } else {
            clearFilters();
          }
        }}
      />
    </div>
  ),
  filterIcon: filtered => (
    <SearchOutlined style={{ color: filtered ? colors.color_keppel : undefined }} />
  ),
});

export const generateExcelData = (data, checkedIndex, statusFilter) => {
  return data.map((data, index) => ({
    index: checkedIndex * 1000 + 1 + index,
    a: data?.node?.student?.fullName,
    b: data?.node?.referenceId,
    c: data?.node?.student?.studentMapping?.externalId ?? '-',
    d: data?.node?.referenceId ?? '-',
    e: data?.node?.student?.registeredPhone,
    f: data?.node?.student?.emailAddress,
    g: data?.node?.market,
    h: data?.node?.partnerCode ?? '-',
    i: data?.node?.stage ? statusFilter.find(t => t.value === data?.node?.stage)?.text : '-',
    j: data?.node?.completedAt ? formatDay(dayFormatType.UKWITHHM, data?.node?.completedAt) : '-',
    k: data?.node?.createdAt ? formatDay(dayFormatType.UKWITHHM, data?.node?.createdAt) : '-',
    l: data?.node?.ownedByUser?.name ?? '-',
    o: data?.node?.destinationUniversity ?? '-',
    p: data?.interestedXbooking?.landlordName ?? '-',
    q: data?.node?.interestedXbooking?.propertyName,
    r: titleCase(data?.node?.interestedXbooking?.roomType),
    s: data?.node?.finalMoveInDate
      ? formatDay(dayFormatType.UKWITHHM, data?.node?.finalMoveInDate)
      : '-',
    t: data?.node?.finalMoveOutDate
      ? formatDay(dayFormatType.UKWITHHM, data?.node?.finalMoveOutDate)
      : '-',
    u: data?.node?.tenancyDurationDaysWeeks?.weeks
      ? data?.node?.tenancyDurationDaysWeeks?.weeks + ' weeks'
      : '-',
    v:
      landlordBookingStatus.find(item => item.value === data?.node?.landlordBookingStatus)?.text ??
      '-',
    w: data?.node?.finalPrice ? (data?.node?.currency ?? '') + data?.node?.finalPrice : '-',
    x: data?.node?.interestedXbooking?.commission?.totalCommissionValue
      ? data?.node?.interestedXbooking?.commission?.currency +
        data?.node?.interestedXbooking?.commission?.totalCommissionValue
      : '-',
    y: data?.node?.interestedXbooking?.commission?.commissionConvertedUsd ?? '-',
    z: data?.node?.interestedXbooking?.commission?.data?.tier?.name ?? '-',
    aa: data?.node?.agentServiceFeeInRmb ?? '-',
  }));
};
